<template>
  <div>
    <el-table :data="patentData.detail.simpleFamilyList" border style="width: 100%">
      <el-table-column prop="appNumber" label="申请号">
        <template slot-scope="scope">
          <span v-for="item in scope.row.appNumber" :key="item">{{item}},</span>
        </template>
      </el-table-column>
      <el-table-column prop="appDate" label="申请日">
      </el-table-column>
      <el-table-column prop="pubNumber" label="公开公告号">
        <template slot-scope="scope">
          <span v-for="item in scope.row.pubNumber" :key="item">{{item}},</span>
        </template>
      </el-table-column>
      <el-table-column prop="pubDate" label="公开公告日">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      patentData: null
    }
  },
  created() {

  },
  mounted() {
    this.patentData = this.data;
  },
  methods: {

  }
}
</script>

<style>

</style>